import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css`
  .update-invite-code-modal {
    width: 320px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 4px;
  }
  .input-wrapper {
    margin-bottom: 8px;
  }
  .update-invite-code-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .update-invite-code-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .update-invite-code-modal :global(.submit-button:hover) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .update-invite-code-modal :global(.cancel-button:hover) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
